<template>
  <div class="main">
    <div class="container">
      <div class="header">
        <div class="pan">
          <img src="@/assets/images/pi_pan2.png" />
          <span>派盘</span>
        </div>
        <div class="logo">
          <img src="@/assets/images/ark.png" />
          <div class="tips">
            <span>数据方舟</span>
            <span>时刻守护您的数据</span>
          </div>
        </div>
        <!-- <div class="header-right">
          <div class="add-service">
            <a target="_top" href="https://www.huluer.com/product/ichainpi-new/">
              <img src="@/assets/images/add_service.png" />
            </a>
          </div>
          <div class="user">
            <a target="_top" v-if="isLogin" href="https://www.huluer.com/usercenter/">
              <img src="@/assets/images/user2.png" />
            </a>
            <a target="_top" v-else href="https://www.huluer.com/wp-login.php">
              <img src="@/assets/images/user.png" />
            </a>
          </div>
        </div> -->
      </div>
      <div class="content-warp">
        <div class="title">
          <!-- <img src="@/assets/images/pi_pan2.png" />
          <span>派盘</span> -->
          <a target="_top" href="https://www.huluer.com/product/ichainpi-new/" class="new-buy">新建派盘</a>
        </div>
        <div class="list">
          <div v-for="(item, index) in serviceList" :key="index" class="item">
            <div class="top">
              <div class="top-left">
                <input
                  v-if="item.id === editId"
                  type="text"
                  v-model="item.name"
                  @blur="save(item)"
                />
                <span v-else class="service-name">
                  <img class="play" src="@/assets/images/play.png">
                  {{ item.name }}</span>
                <img class="line" src="@/assets/images/line.png" />
              </div>
              <div class="top-right">
                <!-- 编辑/保存按钮 -->
                <el-tooltip
                  v-if="item.id !== editId"
                  effect="dark"
                  content="编辑"
                  placement="top"
                >
                  <img
                    @click="edit(item.id)"
                    src="@/assets/images/icon_setting.png"
                    class="icon action"
                  />
                </el-tooltip>
                <el-tooltip v-else effect="dark" content="保存" placement="top">
                  <img
                    src="@/assets/images/icon_save.png"
                    class="icon action"
                    @click="save(item)"
                  />
                </el-tooltip>
                <!-- 开关按钮 -->
                <el-tooltip
                  v-if="isWaiting(item.id)"
                  effect="dark"
                  content="请等待"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_waiting.gif"
                    class="icon action"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 0"
                  effect="dark"
                  content="启动服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_first.png"
                    class="icon action"
                    @click="startService(item.id)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 1"
                  effect="dark"
                  content="启动服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_stop.png"
                    class="icon action"
                    @click="resumeService(item.id)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 2"
                  effect="dark"
                  content="暂停服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_off.png"
                    class="icon action"
                    @click="pauseService(item.id)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 3"
                  effect="dark"
                  content="暂停服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_on.png"
                    class="icon action"
                    @click="pauseService(item.id)"
                  />
                </el-tooltip>
              </div>
            </div>
            <div class="w">
              <div class="context">
                <div class="service-type">
                  <a target="_blank" :href="getUrl(item.subdomain)">
                    <img src="@/assets/images/icon_pan.png" alt="" />
                  </a>
                  <span>电脑云盘</span>
                </div>
                <div class="service-type">
                  <a
                    target="_blank"
                    v-if="
                      [2, 3, 4].some((n) => {
                        return n === item.service_type_id;
                      }) ||
                      (item.service_type_id === 6 && item.user_data.webdav)
                    "
                    :href="getUrl(item.subdomain, 'webdav')"
                  >
                    <img src="@/assets/images/icon_webdav.png" alt="" />
                  </a>
                  <a v-else href="javascript:;" class="no-action">
                    <img src="@/assets/images/icon_webdav2.png" alt="" />
                  </a>
                  <span>APP连接</span>
                </div>
                <div class="service-type">
                  <a
                    target="_blank"
                    v-if="
                      [4].some((n) => {
                        return n === item.service_type_id;
                      }) ||
                      (item.service_type_id === 6 && item.user_data.syncthing)
                    "
                    :href="getUrl(item.subdomain, 'backup')"
                  >
                    <img src="@/assets/images/icon_backup.png" alt="" />
                  </a>
                  <a v-else href="javascript:;" class="no-action">
                    <img src="@/assets/images/icon_backup2.png" alt="" />
                  </a>
                  <span>数据镜像</span>
                </div>
                <div class="service-type">
                  <a
                    target="_blank"
                    v-if="
                      [3, 4].some((n) => {
                        return n === item.service_type_id;
                      }) ||
                      (item.service_type_id === 6 && item.user_data.dongle)
                    "
                    :href="getUrl(item.subdomain, 'dongle')"
                  >
                    <img src="@/assets/images/icon_dongle.png" alt="" />
                  </a>
                  <a v-else href="javascript:;" class="no-action">
                    <img src="@/assets/images/icon_dongle2.png" alt="" />
                  </a>
                  <span>加密套件</span>
                </div>
              </div>
              <div class="bottom">
                <span
                  >{{ item.created_at | dateFormat }}-{{
                    item.expired_at | dateFormat
                  }}</span
                >
                <a target="_top" href="javascript:;" @click="renew(item)">续费</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="renew-dialog" v-show="renewDialogVisible">
        <div class="dialog-main">
          <div class="dialog-header">
            <span>提示</span>
            <span class="action" @click="renewDialogVisible = false">X</span>
          </div>
          <div class="dialog-context">
            您正在为{{renewData.name}}进行续费操作，请选择续费时长？
          </div>
          <div class="dialog-bottom">
            <a class="action button" target="_top" :href="renewData.urlM">按月续费</a>
            <a class="action button" target="_top" :href="renewData.urlY">按年续费</a>
          </div>
        </div>
      </div>
      <div v-show="serviceList && serviceList[0].user_id === 0" class="no-buy">
        当前是演示版本，您可以<a target="_top" href="https://www.huluer.com/product/ichainpi-new/">定制自己的派盘</a>
      </div>
      <div v-show="!isLogin" class="no-login">
        如果您已购买，请<a target="_top" href="https://www.huluer.com/wp-login.php">登录您购买派盘的账户</a>
      </div>
      <div class="footer">
        <div>
          <img class="fish" src="@/assets/images/gray_fish.png" />
          <img class="fish" src="@/assets/images/gray_fish.png" />
          <img class="fish" src="@/assets/images/blue_fish.png" />
          <img class="fish" src="@/assets/images/gray_fish.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/utils/api.js'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'ServiceList2',
  data () {
    return {
      serviceList: null,
      waitingIds: [],
      editId: -1,
      timer: null,
      renewDialogVisible: false,
      renewData: {
        urlM: '',
        urlY: '',
        name: 'xxxx'
      }
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isLogin', 'isPC'])
  },
  async created () {
    this.$store.dispatch('init')
    await this.getServiceList()
  },
  mounted () {
    if (this.timer) {
      clearInterval(this.timer)
    } else {
      this.timer = setInterval(async () => {
        await this.getServiceList()
        console.log(this.serviceList)
      }, 1000 * 20)
    }
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getUrl (subdomain, type) {
      let url = `https://${subdomain}.huluer.vip/`
      switch (type) {
        case 'webdav':
          url += 'dataSync'
          break
        case 'dongle':
          url += 'dongle'
          break
        case 'backup':
          url += 'backup'
          break
        default:
          break
      }
      return url
    },
    async getServiceList () {
      this.serviceList = await api.getServiceList(this.user.id, this.user.jwt)
    },
    async pauseService (serviceId) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      // 添加到等待列表
      this.waitingIds.push(serviceId)
      try {
        await api.pauseService(this.user.id, this.user.jwt, serviceId)
        await this.getServiceList()
      } catch (error) {
        console.log(error)
      }
      // 从等待列表移除
      const index = this.waitingIds.indexOf(serviceId)
      if (index >= 0) this.waitingIds.splice(index, 1)
    },
    async resumeService (serviceId) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      // 添加到等待列表
      this.waitingIds.push(serviceId)
      try {
        await api.resumeService(this.user.id, this.user.jwt, serviceId)
        await this.getServiceList()
      } catch (error) {
        console.log(error)
      }
      // 从等待列表移除
      const index = this.waitingIds.indexOf(serviceId)
      if (index >= 0) this.waitingIds.splice(index, 1)
    },
    async startService (serviceId) {
      if (!this.isPC) {
        alert('请在PC电脑上进行操作!')
        return
      }
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      const r = confirm(
        '请确认（1）这是您的个人电脑；（2）本次服务在此电脑部署云化环境并生成远程文件夹。'
      )
      if (r === false) return
      // 添加到等待列表
      this.waitingIds.push(serviceId)
      try {
        await api.startService(this.user.id, this.user.jwt, serviceId)
        await this.getServiceList()
      } catch (error) {
        console.log(error)
      }
      // 从等待列表移除
      const index = this.waitingIds.indexOf(serviceId)
      if (index >= 0) this.waitingIds.splice(index, 1)
    },
    isWaiting (serviceId) {
      return this.waitingIds.some((id) => {
        return id === serviceId
      })
    },
    edit (serviceId) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      this.editId = serviceId
    },
    async save (item) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      if (!item.name) {
        alert('服务名不能为空')
        return
      }
      await api.updateServiceName(
        this.user.id,
        this.user.jwt,
        item.id,
        item.name
      )
      this.editId = -1
    },
    renew (item) {
      // alert('攻城狮正在开发！敬请期待！')
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      this.renewDialogVisible = true
      this.renewData.urlY = api.renewServiceUrl(item, '12m')
      this.renewData.urlM = api.renewServiceUrl(item, '1m')
      this.renewData.name = item.name
    }
  },
  filters: {
    dateFormat: function (value) {
      const d = new Date(value * 1000)
      const Y = d.getFullYear()
      let M = d.getMonth() + 1
      if (M < 10) {
        M = `0${M}`
      }
      let D = d.getDate()
      if (D < 10) {
        D = `0${D}`
      }
      return `${Y}.${M}.${D}`
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
img {
  height: 100%;
  width: 100%;
}
a {
  text-decoration: none;
  color: #666;
}
.action {
  cursor: pointer;
}
.no-action {
  cursor: default;
}
.main {
  font-size: 16px;
  width: 640px;
  height: 590px;
  background: url(./../assets/images/bg.png) no-repeat;
  border: 2px solid #000;
  margin: 0 auto;
  position: relative;
  .container {
    width: 540px;
    margin: 0 auto;
    font-size: 16px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .pan {
        display: flex;
        align-items: center;
        img {
          width: 3em;
          height: 3em;
          margin-right: 1em;
        }
        span {
          font-size: 1.5em;
        }
      }
      .logo {
        height: 5em;
        display: flex;
        align-items: center;
        img {
          height: 4em;
          width: 5.8em;
          margin-right: 1em;
        }
        .tips {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;
          span {
            padding: 0.25px;
            font-weight: bold;
            color: #777;
          }
        }
      }
      .header-right {
        display: flex;
        .add-service {
          height: 3em;
          width: 3em;
          margin-right: 3em;
        }
        .user {
          height: 3em;
          width: 3em;
        }
      }
    }
    .content-warp {
      margin-top: 0.5em;
      max-height: 465px;
      overflow-x: hidden;
      overflow-y: scroll;
      scrollbar-color: transparent transparent;
      scrollbar-track-color: transparent;
      -ms-scrollbar-track-color: transparent;
      .title {
        display: flex;
        align-items: center;
        margin-bottom: 0.5em;
        justify-content: flex-end;
        .new-buy {
          font-size: 1.3em;
          line-height: 1.3em;
          padding: 0.1em 0.5em 0.2em 0.5em;
          border: none;
          color: #fff;
          border-radius: 5px;
          background-color: #3495ee;
          outline: none;
        }
      }
      .list {
        color: #666;
        .item {
          .top {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
            .icon {
              width: 20px;
              height: 20px;
            }
            .top-left {
              display: flex;
              align-items: center;
              overflow: hidden;
              width: 450px;
              height: 1.5em;
              .service-name {
                display: flex;
                align-items: center;
                padding-right: 1em;
                img {
                  height: 20px;
                  width: 20px;
                }
              }
              .line {
                height: 1px;
              }
              span {
                white-space: nowrap;
              }
              input {
                border: none;
                background: rgba(52, 149, 238, 0.27);
                border-radius: 4px;
                font-size: 1em;
              }
            }
            .top-right {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 60px;
              .content {
                display: flex;
                align-items: center;
              }
            }
          }
          .w {
            padding: 20px 60px;
          }
          .context {
            display: flex;
            justify-content: space-between;
            .service-type {
              display: flex;
              flex-direction: column;
              align-items: center;
              img {
                width: 4em;
                height: 4em;
                margin-bottom: 0.8em;
              }
            }
          }
          .bottom {
            margin-top: 1em;
            text-align: right;
            a {
              color: #3495ee;
              margin-left: 1em;
            }
          }
        }
      }
      &::-webkit-scrollbar {
        display: none;
        width: 5px;
        height: 5px;
      }
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #bbb;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
      }
      &::-webkit-scrollbar-thumb:window-inactive {
        background: #eee;
      }
    }
    .renew-dialog {
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.3);
      border-radius: 5px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .dialog-main {
        padding: 10px 15px;
        width: 20em;
        height: 10em;
        border-radius: 5px;
        background-color: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .dialog-header{
          display: flex;
          justify-content: space-between;
          margin-bottom: 1em;
        }
        .dialog-context {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .dialog-bottom {
          display: flex;
          justify-content: space-around;
          padding: 20px;
          .button {
            font-size: 1.0em;
            line-height: 1.0em;
            padding: 0.1em 0.5em 0.2em 0.5em;
            border: none;
            color: #fff;
            border-radius: 5px;
            background-color: #3495ee;
            outline: none;
          }
        }
      }
    }
    .no-buy,.no-login {
      text-align: center;
      padding: 1em;
      a {
        color: #3495ee;
      }
    }
    .footer {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      .fish {
        height: 10px;
        width: 24px;
        margin: 0 10px;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .main {
    width: 320px !important;
    height: 450px !important;
    .container {
      width: 300px !important;
      font-size: 12px;
      .header {
        .header-right {
          .add-service {
            margin-right: 1em;
          }
        }
      }
      .top-left {
        width: 210px !important;
      }
      .content-warp {
        max-height: 350px !important;
        .list .item .w {
          padding: 1em 1em;
        }
      }
      .footer .fish {
        margin: 0 5px;
      }
    }
  }
}
</style>
